const squareSources = '/images/cases/telstore-square-840.webp 840w, /images/cases/telstore-square.webp 1254w';
const wideSources = '/images/cases/telstore-840.webp 840w, /images/cases/telstore-1280.webp 1280w, /images/cases/telstore.webp 1672w';

// Готовые композиции, не CSS-кроп: на телефоне весь текст остаётся в квадрате.
export default function TelStoreCover({ alt, preview = false, wide = false }) {
  const sizes = wide
    ? '(max-width: 800px) calc(100vw - 40px), (max-width: 1280px) 46vw, 545px'
    : preview
    ? '(max-width: 640px) calc(100vw - 42px), (max-width: 1024px) calc(100vw - 66px), (max-width: 1280px) calc((100vw - 99px) / 2), 590px'
    : '(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) calc(100vw - 64px), (max-width: 1280px) calc(100vw - 96px), 1184px';

  return (
    <picture className={`telstore-cover${preview ? '' : ' telstore-cover--detail'}`}>
      {!wide && <source media="(max-width: 640px)" srcSet={squareSources} sizes={sizes} width="1254" height="1254" />}
      {preview && !wide && (
        <source media="(min-width: 1025px)" srcSet={squareSources} sizes={sizes} width="1254" height="1254" />
      )}
      <img
        src="/images/cases/telstore.webp"
        srcSet={wideSources}
        sizes={sizes}
        alt={alt}
        width="1672"
        height="941"
        loading={preview ? 'lazy' : 'eager'}
        decoding="async"
      />
    </picture>
  );
}
